// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAZC-Zl30d0ydK6UeAQ7MQ81-6-MHm84J0",
    authDomain: "wecareehs-cf458.firebaseapp.com",
    projectId: "wecareehs-cf458",
    storageBucket: "wecareehs-cf458.firebasestorage.app",
    messagingSenderId: "975838574981",
    appId: "1:975838574981:web:52fc83c79b944578856cec",
    measurementId: "G-D59YFSCCP0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db, analytics };
